import { render, staticRenderFns } from "./deactivateModel.vue?vue&type=template&id=1b60caf8"
import script from "./deactivateModel.vue?vue&type=script&lang=js"
export * from "./deactivateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b60caf8')) {
      api.createRecord('1b60caf8', component.options)
    } else {
      api.reload('1b60caf8', component.options)
    }
    module.hot.accept("./deactivateModel.vue?vue&type=template&id=1b60caf8", function () {
      api.rerender('1b60caf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyCustomerManage/deactivateModel.vue"
export default component.exports